import Box from '@mui/material/Box';
import { visuallyHidden } from '@mui/utils';

import { countOrNever, type DocumentRow } from './documentLabels';

/**
 * A document's views or downloads, as the table and the drawer write them:
 * the count, or for a document never published a dash a screen reader names
 * "Never published" (P17). `testId` is the dash's.
 */
export function DocumentCount({
  row,
  count,
  testId,
}: {
  row: DocumentRow;
  count: number;
  testId: string;
}) {
  return (
    countOrNever(row, count) ?? (
      <span data-testid={testId}>
        <span aria-hidden="true">—</span>
        <Box component="span" sx={visuallyHidden}>
          Never published
        </Box>
      </span>
    )
  );
}
